import { render, staticRenderFns } from "./ClaimStaging.vue?vue&type=template&id=37849cf1&"
import script from "./ClaimStaging.vue?vue&type=script&lang=js&"
export * from "./ClaimStaging.vue?vue&type=script&lang=js&"
import style0 from "./ClaimStaging.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClaimStaging.vue"
export default component.exports